import { css, cx } from 'emotion';
import React, { useEffect, useRef } from 'react';
import closeIcon from '../../assets/closeIcon.svg';

const modalStyle = css`
  position: fixed;
  z-index: 7;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
`;

const removeDefaultButtonStyle = css`
  background: transparent;
  border: none;
  cursor: pointer;
`;

const modalContentStyle = css`
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  border-top: 2px solid var(--primaryBrand);
  width: 50%;
  height: 80%;
  overflow: hidden;
  border-radius: 12px;
  padding: 1.5rem 1rem;
  @media (max-width: 768px) {
    height: 100%;
    width: 100%;
    border-radius: 0;
  }
`;

const modalHeaderStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
`;

const titleStyle = css`
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1.2em;
  letter-spacing: -0.03em;
  color: var(--dark);
`;

const hiddenStyle = css`
  display: none;
`;

export const Modal = props => {
  const { children, show, handleClose, customModalStyle, title, closable = true } = props;
  const modalRef = useRef();
  const containerRef = useRef();

  useEffect(() => {
    const handleClickOutside = event => {
      if (closable && modalRef.current?.contains(event.target) && !containerRef.current?.contains(event.target)) {
        handleClose();
      }
    };
    window.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [closable, handleClose]);

  return (
    <div ref={modalRef} className={cx(modalStyle, show || hiddenStyle)}>
      <div ref={containerRef} className={cx(modalContentStyle, customModalStyle)}>
        <header className={modalHeaderStyle}>
          <h4 className={titleStyle}>{title}</h4>
          <button className={removeDefaultButtonStyle} onClick={handleClose} type="button">
            <img src={closeIcon} alt="close" />
          </button>
        </header>
        <>{children}</>
      </div>
    </div>
  );
};
